import { render, staticRenderFns } from "./PublicElement.vue?vue&type=template&id=50d71fd6&scoped=true"
import script from "./PublicElement.vue?vue&type=script&lang=js"
export * from "./PublicElement.vue?vue&type=script&lang=js"
import style0 from "./PublicElement.vue?vue&type=style&index=0&id=50d71fd6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d71fd6",
  null
  
)

export default component.exports